
<template>
  <el-dialog
    width="560px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="visibleDialog"
    append-to-body
  >
    <div class="dialog-wrap">
      <div class="tip-content">
        <pre>
        1、名单里的商家不能使用除“默认发货货期”以外的其他货期设置。
        2、导入后替换原本的商家名单。
        3、导入的格式为：从A2~A无限，一个单元格一个商家ID。
        </pre>
      </div>

      <div class="button-wrap">
        <el-upload
          style="margin-right: 12px"
          :action="importFileApi"
          :show-file-list="false"
          :auto-upload="true"
          name="excel"
          :on-success="importFileSuccess"
          with-credentials
        >
          <el-button type="primary" size="mini" icon="el-icon-top">
            导入黑名单
          </el-button>
        </el-upload>

        <el-button
          type="success"
          size="mini"
          icon="el-icon-bottom"
          @click="handleExportFile"
        >
          导出黑名单
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "SpecialBlacklistDialog",
  data() {
    return {
      visibleDialog: false,
      importFileApi: `${apiBaseURL}/erp/Supply/importSpecialDeliveryBlackList`,
    };
  },

  methods: {
    // 显示弹框
    showDialog() {
      this.visibleDialog = true;
    },
    // 成功导入
    importFileSuccess(data) {
      if (data.code !== 200) {
        this.$message.e(data.msg);
      } else {
        this.visibleDialog = false;
        this.$message.success("更新成功");
      }
    },
    // 导出黑名单
    handleExportFile() {
      this.$post("/erp/Supply/exportSpecialDeliveryBlackList").then(
        (rs) => {
          this.visibleDialog = false;
          window.open(apiBaseURL + rs.file);
        }
      );
    },
  },
};
</script>

<style scoped>
.dialog-wrap {
  position: relative;
}

.dialog-wrap .button-wrap {
  display: flex;
  justify-content: flex-end;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/components/SpecialBlacklistDialog.vue